import {gql} from 'apollo-angular';


export default gql`
mutation ResendInvitation($input: ResendInvitationInput!) {
  resendInvitation(input: $input)
}
`;
